
/*
    provides waiter service
    any function can be added to waiter queue
    and this function will be called every initialPollInterval
    until return true or timeout happened
 */

class Waiter {
    constructor(options) {
        this.currentPollInterval = 0;
        this.initialPollInterval = ! options || options.pollInterval === undefined ? 50 : options.pollInterval
        this._tasks = [];
        this.updateTask = null
        this.debug = options && options.debug !== undefined ? options.debug : false;
        this.counter = 0
    }

    add(fn, timeout, fn_timeout) {
        if (typeof fn !== 'function') {
            console.warn(`wrong listener type: ${typeof fn}`);
            return;
        }
        this.counter++
        const newListener = {
            id: this.counter,
            fn: fn,
            timeout: new Date().getTime() + timeout,
            fn_timeout: fn_timeout
        };
        this._hasTasks = true
        if (this.debug)
            console.log(`Waiter: task [${newListener.id}] was added with timeout ${timeout}`)
        this._tasks.push(newListener);
        this.setPollInterval(this.initialPollInterval)
    }

    setPollInterval(ms) {
        if (ms === 0 || ms !== this.currentPollInterval)  {
            if (this.updateTask != null) {
                if (this.debug && ms === 0)
                    console.log(`Waiter: is stopped`)
                clearInterval(this.updateTask)
                this.updateTask = null;
                this.currentPollInterval = 0
            }
        }
        if (ms !== this.currentPollInterval) {
            this.currentPollInterval = ms
            this.updateTask = setInterval(
                function () {
                    this._processQueue()
                    if (this._tasks.length === 0 && !this._hasTasks) {
                        clearInterval(this.updateTask)
                        this.updateTask = null;
                        this.currentPollInterval = 0
                        if (this.debug)
                            console.log(`Waiter: queue is empty, stopped`)
                    }
                }.bind(this),
                ms
            );
            if (this.debug)
                console.log(`Waiter: started`)
        }
    }

    _processQueue() {
        this._hasTasks = false
        let timestamp = new Date().getTime()
        for (let i in this._tasks) {
            let q = this._tasks[i]
            if (!q)
                continue
            this._hasTasks = true
            if (q.fn()) {
                delete this._tasks[i]
                if (this.debug)
                    console.log(`Waiter: task [${q.id}] is finished`)
            }
            if (timestamp > q.timeout) {
                if (this.debug)
                    console.log(`Waiter: task [${q.id}] is closed with timeout`)
                if (q.fn_timeout)
                    q.fn_timeout()
                delete this._tasks[i]
            }
        }
        if (this._tasks.length > 0) {
            if (!this._hasTasks)
                this._tasks = []
        }
    }
}

export { Waiter};
